import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import styles from "./Lifestyle.module.sass";
import Icon from "../../../components/Icon";
import ScrollParallax from "../../../components/ScrollParallax";

const items = [
  {
    title: "Automatisation des contrats alternance",
    image: "/images/content/contrat-app-1.png",
    image2x: "/images/content/contrat-app-1.png",
    content:
      "Questionnaires 100% en ligne pour l’étudiant et son entreprise.Digitalisation des CERFA et conventions de formation qui sont remplis automatiquement.Vos étudiants et entreprises partenaires bénéficient de toute l'automatisation grâce à notre IA et la vérification des champs.",
  },
  {
    title: "Vérification des données",
    image: "/images/content/contrat-app-2.png",
    image2x: "/images/content/contrat-app-2.png",
    content:
      "Tous les champs sont vérifiés pour éviter les erreurs. Le salaire est rempli automatiquement grâce à nos algorithmes.-> 92% des dossiers envoyés par Edutio sont acceptés du 1er coup chez les OPCO.",
  },
  {
    title: "Notifications automatiques",
    image: "/images/content/contrat-app-3.png",
    image2x: "/images/content/contrat-app-3.png",
    content:
      "Maximisation du temps de traitement des contrats grâce à des emails de relance préconfigurés en cas d’action en retard d’une des parties. Gain de temps pour le montage des contrats d'alternance",
  },
  {
    title: "Interconnexion aux OPCO",
    image: "/images/content/contrat-app-4.png",
    image2x: "/images/content/contrat-app-4.png",
    content:
      "Notre logiciel pour les centres de formation (CFA) bénéficie de l'accrochage avec tous les OPCO, qui certifie la qualité des données que nous envoyons.",
  },
  {
    title: "Tableaux de bord des contrats",
    image: "/images/content/contrat-app-5.png",
    image2x: "/images/content/contrat-app-5.png",
    content:
      "Grâce à un tableau de bord complet, Edutio devient votre CRM interne. Vous avez accès en temps réel :Toutes les actions requises et points de blocage de vos contrats d’alternanceL'avancement des contrats d'apprentissage et validation de l’OPCOUne vision à 360° de tous vos dossiers et leurs statistiques pour une gestion plus simple",
  },
];

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

const Lifestyle = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-next" size="14" />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-prev" size="14" />
      </SlickArrow>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 100000,
        settings: "unslick",
      },
    ],
  };

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.head}>
          <div className={cn("stage-small", styles.stage)}>Innovation pédagogique</div>
          <h2 className={cn("h2", styles.title)}>Transformez votre approche administrative</h2>
          <div className={styles.info}>
            Découvrez comment notre technologie révolutionne chaque aspect de la gestion des contrats d'alternance.{" "}
          </div>
        </div>
        <div className={styles.wrap}>
          <Slider
            className={cn("lifestyle-slider", styles.slider)}
            {...settings}
          >
            {items.map((x, index) => (
              <ScrollParallax className={styles.item} key={index}>
                <div className={styles.row}>
                  <div className={styles.col}>
                    <div className={styles.details}>
                      <div className={styles.number}>0{index + 1}.</div>
                      <div className={styles.category}>{x.title}</div>
                      <div className={styles.content}>{x.content}</div>
                    </div>
                  </div>
                  <div className={styles.col}>
                    <img
                      srcSet={`${x.image2x} 2x`}
                      src={x.image}
                      alt="Lifestyle"
                    />
                  </div>
                </div>
              </ScrollParallax>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Lifestyle;
